const translations = {
  en: {
    // Nav & Layout
    'nav.discover': 'Discover',
    'nav.feed': 'Feed',
    'nav.leaderboard': 'Leaderboard',
    'nav.submit': 'Submit',
    'nav.login': 'Log in',
    'nav.signup': 'Get Started',
    'nav.profile': 'Profile',
    'nav.messages': 'Messages',
    'nav.editProfile': 'Edit Profile',
    'nav.admin': 'Admin Dashboard',
    'nav.logout': 'Log out',
    'nav.submitProject': 'Submit Project',

    // Footer
    'footer.platform': 'Platform',
    'footer.legal': 'Legal',
    'footer.terms': 'Terms of Service',
    'footer.privacy': 'Privacy Policy',
    'footer.description': 'Where ideas find supporters, feedback, and momentum before fundraising.',
    'footer.rights': 'All rights reserved.',

    // Landing Page
    'landing.badge': 'The momentum platform for ideas',
    'landing.title1': 'Launch Ideas. ',
    'landing.titleHighlight': 'Build',
    'landing.title2': ' Momentum.',
    'landing.subtitle': 'Fikkr gives founders and builders a public home for their ideas — to collect supporters, feedback, early signups, and proof of traction before fundraising.',
    'landing.exploreProjects': 'Explore Ideas',
    'landing.getStarted': 'Start Your Page',
    'landing.seeTrending': 'Explore Ideas',
    'landing.noCode': 'No code. Go live in minutes.',
    'landing.submitYourProject': 'Submit Your Idea',
    'landing.createAccount': 'Create Account',
    'landing.viewAll': 'View All',

    // Problem section
    'landing.problemTitle': 'Most ideas die before they get a real chance.',
    'landing.problemDesc': 'Not because they are bad — but because they lack visibility, feedback, structure, and early believers.',
    'landing.problemNoAudience': 'No audience',
    'landing.problemNoAudienceDesc': 'Great ideas stay invisible without a way to reach people who care.',
    'landing.problemNoSignal': 'No signal',
    'landing.problemNoSignalDesc': 'Without proof of interest, it is impossible to attract partners or investors.',
    'landing.problemNoMomentum': 'No momentum',
    'landing.problemNoMomentumDesc': 'Without early traction, motivation fades and ideas get abandoned.',

    // Solution section
    'landing.solutionTitle': 'Fikkr gives every idea a place to grow.',
    'landing.solIdeaPage': 'Idea Page',
    'landing.solIdeaPageDesc': "Your idea's public home — clean, professional, shareable.",
    'landing.solSupporters': 'Supporters',
    'landing.solSupportersDesc': 'Collect early believers who back your vision.',
    'landing.solFeedback': 'Feedback',
    'landing.solFeedbackDesc': 'Get useful input from people who care.',
    'landing.solTraction': 'Waitlist & Traction',
    'landing.solTractionDesc': 'Turn interest into real, measurable signal.',

    // How it works
    'landing.howTitle': 'How Fikkr works',
    'landing.howStep1Title': 'Publish your idea',
    'landing.howStep1Desc': 'Create a clean public page in minutes. No code, no hassle.',
    'landing.howStep2Title': 'Share and collect momentum',
    'landing.howStep2Desc': 'Get supporters, feedback, followers, and waitlist signups.',
    'landing.howStep3Title': 'Grow into a real project',
    'landing.howStep3Desc': 'Use traction to attract users, teammates, partners, or investors.',

    // Who is it for
    'landing.whoTitle': 'Built for people who are starting from zero',
    'landing.whoFounders': 'Founders',
    'landing.whoFoundersDesc': 'Validate before you build',
    'landing.whoIndie': 'Indie Makers',
    'landing.whoIndieDesc': 'Ship ideas, find your audience',
    'landing.whoStudents': 'Student Entrepreneurs',
    'landing.whoStudentsDesc': 'Launch your first project',
    'landing.whoCreators': 'Creators',
    'landing.whoCreatorsDesc': 'Build products, not just content',
    'landing.whoTeams': 'Early Teams',
    'landing.whoTeamsDesc': 'Get traction before fundraising',

    // Trending section
    'landing.trendingProjects': 'Trending Ideas',
    'landing.trendingDesc': 'Ideas gaining momentum right now',
    'landing.noProjects': 'No ideas yet',
    'landing.beFirst': 'Be the first to publish your idea!',

    // CTA
    'landing.ctaTitle': "Your idea doesn't need permission. It needs momentum.",
    'landing.ctaDesc': 'Create your Fikkr page and start building traction today.',

    // Discover Page
    'discover.title': 'Discover Projects',
    'discover.subtitle': 'Find and support innovative ideas from around the world',
    'discover.filters': 'Filters:',
    'discover.allCategories': 'All Categories',
    'discover.projectsFound': '{count} project(s) found',
    'discover.filteredBy': 'Filtered by:',
    'discover.noProjects': 'No projects found',
    'discover.noCategoryProjects': 'No projects in this category yet. Be the first!',
    'discover.beFirstSubmit': 'Be the first to submit a project!',
    'discover.loadMore': 'Load More Projects',

    // Feed types
    'feed.trending': 'Trending',
    'feed.rising': 'Rising',
    'feed.community': 'Community Choice',
    'feed.smart_picks': 'Smart Picks',
    'feed.latest': 'Latest',

    // Leaderboard
    'leaderboard.title': 'Leaderboard',
    'leaderboard.subtitle': 'Top supporters and trending projects',
    'leaderboard.topSupporters': 'Top Supporters',
    'leaderboard.topProjects': 'Top Projects',
    'leaderboard.boostsGiven': 'boosts given',
    'leaderboard.momentum': 'momentum',
    'leaderboard.raised': '{amount} raised',
    'leaderboard.supporters': '{count} supporters',
    'leaderboard.noSupporters': 'No supporters yet. Be the first!',
    'leaderboard.noProjectsYet': 'No projects yet. Submit the first one!',

    // Auth Pages
    'auth.welcomeBack': 'Welcome Back',
    'auth.loginSubtitle': 'Log in to publish ideas and build momentum',
    'auth.continueGoogle': 'Continue with Google',
    'auth.or': 'or',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.fullName': 'Full Name',
    'auth.logIn': 'Log In',
    'auth.noAccount': "Don't have an account?",
    'auth.signUp': 'Sign up',
    'auth.joinFikkr': 'Join Fikkr',
    'auth.signupSubtitle': 'Turn your ideas into momentum',
    'auth.createAccountBtn': 'Create Account',
    'auth.haveAccount': 'Already have an account?',
    'auth.logInLink': 'Log in',
    'auth.passwordHint': 'At least 6 characters',
    'auth.welcomeBackToast': 'Welcome back!',
    'auth.accountCreated': 'Account created! Welcome to Fikkr.',

    // Profile Page
    'profile.editProfile': 'Edit Profile',
    'profile.message': 'Message',
    'profile.joined': 'Joined {time}',
    'profile.boostsGiven': '{count} boosts given',
    'profile.projects': 'Projects',
    'profile.updates': 'Updates',
    'profile.recentBoosts': 'Recent Boosts',
    'profile.noProjects': 'No projects yet',
    'profile.noProjectsDesc': "This user hasn't submitted any projects",
    'profile.noUpdates': 'No updates yet',
    'profile.shareFirst': 'Share your first update above!',
    'profile.noUpdatesDesc': 'No updates shared yet',
    'profile.noBoosts': 'No boosts yet',
    'profile.noBoostsDesc': "This user hasn't boosted any projects yet",
    'profile.stats': 'Stats',
    'profile.userNotFound': 'User Not Found',

    // Edit Profile Page
    'editProfile.title': 'Edit Profile',
    'editProfile.back': 'Back',
    'editProfile.pictureUrl': 'Profile Picture URL',
    'editProfile.displayName': 'Display Name',
    'editProfile.bio': 'Bio',
    'editProfile.bioPlaceholder': 'Tell us about yourself...',
    'editProfile.saveChanges': 'Save Changes',
    'editProfile.cancel': 'Cancel',
    'editProfile.noChanges': 'No changes to save',
    'editProfile.updated': 'Profile updated!',

    // Messages Page
    'messages.title': 'Messages',
    'messages.newMessage': 'New Message',
    'messages.noConversations': 'No conversations yet',
    'messages.startConversation': 'Start a conversation with someone',
    'messages.findUsers': 'Find Users',
    'messages.selectConversation': 'Select a conversation',
    'messages.chooseConversation': 'Choose a conversation from the sidebar or start a new one',
    'messages.typeMessage': 'Type a message...',
    'messages.send': 'Send',
    'messages.you': 'You',

    // Following Feed Page
    'followingFeed.title': 'Feed',
    'followingFeed.subtitle': 'Updates from people you follow',
    'followingFeed.loginPrompt': 'Log in to see updates from people you follow',
    'followingFeed.empty': 'Your feed is empty',
    'followingFeed.emptyDesc': 'Follow users to see their projects and updates here',
    'followingFeed.discoverProjects': 'Discover Projects',
    'followingFeed.all': 'All',
    'followingFeed.projects': 'Projects',
    'followingFeed.updates': 'Updates',
    'followingFeed.yourFeed': 'Your Feed',

    // Notifications
    'notifications.title': 'Notifications',
    'notifications.markAllRead': 'Mark all read',
    'notifications.empty': 'No notifications yet',

    // Follow
    'follow.follow': 'Follow',
    'follow.following': 'Following',
    'follow.followers': 'Followers',

    // Components
    'component.smartPick': 'Smart Pick',
    'component.searchUsers': 'Search users...',
    'component.noUsersFound': 'No users found',
    'component.updateDeleted': 'Update deleted',
    'component.shareUpdate': "What's new with your project?",
    'component.selectProject': 'Link to project (optional)',
    'component.noProject': 'No project',
    'component.postUpdate': 'Post Update',

    // Common
    'common.loading': 'Loading...',
    'common.error': 'Error',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.delete': 'Delete',
    'common.search': 'Search',
    'common.back': 'Back',

    // Submit Project
    'submit.linksMedia': 'Links & Media',
    'submit.linksMediaDesc': 'Add links to your project (all optional)',
    'submit.coverImage': 'Cover Image',
    'submit.clickToUpload': 'Click to upload an image',
    'submit.imageFormats': 'JPEG, PNG, GIF, WebP (max 5MB)',
    'submit.orPasteUrl': 'Or paste an image URL:',
    'submit.demoUrl': 'Demo / Website URL',
    'submit.invalidImageType': 'Please select a valid image file',
    'submit.imageTooLarge': 'Image must be smaller than 5MB',
    'submit.imageUploaded': 'Image uploaded successfully!',
    'submit.uploadFailed': 'Failed to upload image',

    // Legal
    'legal.disclaimer': 'This platform does not offer investments. All contributions are voluntary support. No equity, profit, or financial return is promised.',
    'legal.notFound': 'Page Not Found',
    'legal.notFoundDesc': 'The page you are looking for does not exist or has not been created yet.',

    // Footer
    'footer.kvkk': 'KVKK',

    // Admin Panel
    'admin.title': 'Admin Dashboard',
    'admin.subtitle': 'Platform management & analytics',
    'admin.refresh': 'Refresh',
    'admin.refreshed': 'Data refreshed',
    'admin.loadError': 'Failed to load data',
    'admin.saveError': 'Failed to save',
    'admin.today': 'today',

    // Admin Tabs
    'admin.tabOverview': 'Overview',
    'admin.tabSettings': 'Site Settings',
    'admin.tabPages': 'Legal Pages',
    'admin.tabHomepage': 'Homepage',
    'admin.tabSystem': 'System',

    // Admin Overview
    'admin.totalUsers': 'Total Users',
    'admin.totalProjects': 'Total Projects',
    'admin.totalBoosts': 'Total Boosts',
    'admin.totalRaised': 'Total Raised',
    'admin.boostBreakdown': 'Boost Breakdown',
    'admin.freeBoosts': 'Free Boosts',
    'admin.timeBoosts': 'Time Boosts',
    'admin.moneyBoosts': 'Money Boosts',
    'admin.flaggedContent': 'Flagged Content',
    'admin.noFlagged': 'No flagged content',
    'admin.smartPicks': 'Smart Picks Curation',

    // Admin Settings
    'admin.siteInfo': 'Site Information',
    'admin.siteName': 'Site Name',
    'admin.logoUrl': 'Logo URL',
    'admin.logoUrlHint': 'Enter the URL of your logo image. Leave empty to use the default icon.',
    'admin.logoPreview': 'Preview:',
    'admin.seoTitle': 'SEO Title',
    'admin.seoTitleHint': 'Shown in browser tabs and search results',
    'admin.seoDescription': 'SEO Description',
    'admin.seoDescHint': 'Shown in search engine results (max 160 chars recommended)',
    'admin.googleCodes': 'Google Integration',
    'admin.gaId': 'Google Analytics ID',
    'admin.gaHint': 'Your Google Analytics measurement ID (e.g., G-XXXXXXXXXX)',
    'admin.verificationCode': 'Google Search Console Verification',
    'admin.verificationHint': 'Meta tag content value for Google verification',
    'admin.customCode': 'Custom Code',
    'admin.customCss': 'Custom CSS',
    'admin.customHeadScripts': 'Custom Head Scripts',
    'admin.saveSettings': 'Save Settings',
    'admin.settingsSaved': 'Settings saved successfully',

    // Admin Pages
    'admin.pageTerms': 'Terms of Service',
    'admin.pagePrivacy': 'Privacy Policy',
    'admin.pageKvkk': 'KVKK',
    'admin.pageTitle': 'Page Title',
    'admin.pageTitlePlaceholder': 'Enter page title...',
    'admin.pageContent': 'Page Content',
    'admin.htmlSupported': '(HTML supported)',
    'admin.pageContentPlaceholder': 'Enter page content (HTML is supported)...',
    'admin.pagePreviewHint': 'Preview: visit /page/terms, /page/privacy, or /page/kvkk',
    'admin.savePage': 'Save Page',
    'admin.pageSaved': 'Page saved successfully',
    'admin.fillRequired': 'Title and content are required',

    // Admin Homepage
    'admin.heroSection': 'Hero Section',
    'admin.heroDesc': 'Customize the main hero section of the landing page. Leave fields empty to use default translations.',
    'admin.heroTitle1': 'Title Part 1',
    'admin.heroTitle1Hint': 'Text before the highlighted word',
    'admin.heroHighlight': 'Highlighted Word',
    'admin.heroHighlightHint': 'The gradient-colored keyword',
    'admin.heroTitle2': 'Title Part 2',
    'admin.heroSubtitle': 'Subtitle',
    'admin.preview': 'Preview',
    'admin.saveHomepage': 'Save Homepage',
    'admin.homepageSaved': 'Homepage settings saved',

    // Admin System
    'admin.serverInfo': 'Server Information',
    'admin.status': 'Status',
    'admin.pythonVersion': 'Python Version',
    'admin.platform': 'Platform',
    'admin.databaseInfo': 'Database Information',
    'admin.dbSize': 'Database Size',
    'admin.collections': 'Collections',
    'admin.totalDocs': 'Total Documents',
    'admin.collectionCounts': 'Collection Counts',
    'admin.messages': 'Messages',
    'admin.notifications': 'Notifications',

    // Relative time
    'time.justNow': 'just now',
    'time.minutesAgo': '{count}m ago',
    'time.hoursAgo': '{count}h ago',
    'time.daysAgo': '{count}d ago',
  },

  tr: {
    // Nav & Layout
    'nav.discover': 'Kesifet',
    'nav.feed': 'Akis',
    'nav.leaderboard': 'Siralamalar',
    'nav.submit': 'Gonder',
    'nav.login': 'Giris Yap',
    'nav.signup': 'Basla',
    'nav.profile': 'Profil',
    'nav.messages': 'Mesajlar',
    'nav.editProfile': 'Profili Duzenle',
    'nav.admin': 'Yonetim Paneli',
    'nav.logout': 'Cikis Yap',
    'nav.submitProject': 'Proje Gonder',

    // Footer
    'footer.platform': 'Platform',
    'footer.legal': 'Yasal',
    'footer.terms': 'Kullanim Sartlari',
    'footer.privacy': 'Gizlilik Politikasi',
    'footer.description': 'Fikirlerin yatirim oncesi destekci, geri bildirim ve ivme kazandigi yer.',
    'footer.rights': 'Tum haklari saklidir.',

    // Landing Page
    'landing.badge': 'Fikirler icin ivme platformu',
    'landing.title1': 'Fikirleri ',
    'landing.titleHighlight': 'Baslat.',
    'landing.title2': ' Ivme Olustur.',
    'landing.subtitle': 'Fikkr, kuruculara ve ureticilere fikirlerini sergilemek, destekci toplamak, geri bildirim almak ve yatirim oncesi ivme kazanmak icin profesyonel bir sayfa sunar.',
    'landing.exploreProjects': 'Fikirleri Kesfet',
    'landing.getStarted': 'Sayfani Olustur',
    'landing.seeTrending': 'Fikirleri Kesfet',
    'landing.noCode': 'Kod gerektirmez. Dakikalar icinde yayina al.',
    'landing.submitYourProject': 'Fikrini Paylas',
    'landing.createAccount': 'Hesap Olustur',
    'landing.viewAll': 'Tumunu Gor',

    // Problem section
    'landing.problemTitle': 'Cogu fikir gercek bir sans bulamadan oluyor.',
    'landing.problemDesc': 'Kotu oldukları icin degil — gorunurluk, geri bildirim, yapi ve erken inananlardan yoksun olduklari icin.',
    'landing.problemNoAudience': 'Kitle yok',
    'landing.problemNoAudienceDesc': 'Harika fikirler, ilgilenen insanlara ulasmanin bir yolu olmadan gorunmez kalir.',
    'landing.problemNoSignal': 'Sinyal yok',
    'landing.problemNoSignalDesc': 'Ilgi kaniti olmadan ortak veya yatirimci cekmek imkansizdir.',
    'landing.problemNoMomentum': 'Ivme yok',
    'landing.problemNoMomentumDesc': 'Erken cekis olmadan motivasyon azalir ve fikirler terk edilir.',

    // Solution section
    'landing.solutionTitle': 'Fikkr her fikre buyumek icin bir yer verir.',
    'landing.solIdeaPage': 'Fikir Sayfasi',
    'landing.solIdeaPageDesc': 'Fikrinizin profesyonel, paylasılabilir kamusal sayfasi.',
    'landing.solSupporters': 'Destekçiler',
    'landing.solSupportersDesc': 'Vizyonunuza inanan erken destekçileri toplayin.',
    'landing.solFeedback': 'Geri Bildirim',
    'landing.solFeedbackDesc': 'Ilgilenen insanlardan faydali geri bildirim alin.',
    'landing.solTraction': 'Bekleme Listesi & Cekis',
    'landing.solTractionDesc': 'Ilgiyi gercek, olculebilir bir sinyale donusturun.',

    // How it works
    'landing.howTitle': 'Fikkr nasil calisir',
    'landing.howStep1Title': 'Fikrini yayinla',
    'landing.howStep1Desc': 'Dakikalar icinde temiz bir kamusal sayfa olustur. Kod yok, zorluk yok.',
    'landing.howStep2Title': 'Paylas ve ivme topla',
    'landing.howStep2Desc': 'Destekci, geri bildirim, takipci ve bekleme listesi kayitlari topla.',
    'landing.howStep3Title': 'Gercek bir projeye donustur',
    'landing.howStep3Desc': 'Cekisi kullanarak kullanici, ekip arkadasi, ortak veya yatirimci cek.',

    // Who is it for
    'landing.whoTitle': 'Sifirdan baslayan insanlar icin tasarlandi',
    'landing.whoFounders': 'Kurucular',
    'landing.whoFoundersDesc': 'Insa etmeden once dogrula',
    'landing.whoIndie': 'Bagimsiz Ureticiler',
    'landing.whoIndieDesc': 'Fikir gonder, kitleni bul',
    'landing.whoStudents': 'Ogrenci Girisimciler',
    'landing.whoStudentsDesc': 'Ilk projeni baslat',
    'landing.whoCreators': 'Icerik Ureticileri',
    'landing.whoCreatorsDesc': 'Sadece icerik degil, urun olustur',
    'landing.whoTeams': 'Erken Ekipler',
    'landing.whoTeamsDesc': 'Yatirim oncesi ivme kazan',

    // Trending section
    'landing.trendingProjects': 'Trend Fikirler',
    'landing.trendingDesc': 'Su anda ivme kazanan fikirler',
    'landing.noProjects': 'Henuz fikir yok',
    'landing.beFirst': 'Fikrini ilk sen yayinla!',

    // CTA
    'landing.ctaTitle': 'Fikrin izne ihtiyac duymuyor. Ivmeye ihtiyac duyuyor.',
    'landing.ctaDesc': 'Fikkr sayfani olustur ve bugunden itibaren cekis olusturmaya basla.',

    // Discover Page
    'discover.title': 'Projeleri Kesfet',
    'discover.subtitle': 'Dunyanin dort bir yanindan yenilikci fikirleri bulun ve destekleyin',
    'discover.filters': 'Filtreler:',
    'discover.allCategories': 'Tum Kategoriler',
    'discover.projectsFound': '{count} proje bulundu',
    'discover.filteredBy': 'Filtre:',
    'discover.noProjects': 'Proje bulunamadi',
    'discover.noCategoryProjects': 'Bu kategoride henuz proje yok. Ilk siz olun!',
    'discover.beFirstSubmit': 'Bir proje gondermek icin ilk siz olun!',
    'discover.loadMore': 'Daha Fazla Proje Yukle',

    // Feed types
    'feed.trending': 'Trend',
    'feed.rising': 'Yukselen',
    'feed.community': 'Topluluk Secimi',
    'feed.smart_picks': 'Akilli Secimler',
    'feed.latest': 'En Yeni',

    // Leaderboard
    'leaderboard.title': 'Siralamalar',
    'leaderboard.subtitle': 'En iyi destekçiler ve trend projeler',
    'leaderboard.topSupporters': 'En Iyi Destekçiler',
    'leaderboard.topProjects': 'En Iyi Projeler',
    'leaderboard.boostsGiven': 'destek verildi',
    'leaderboard.momentum': 'ivme',
    'leaderboard.raised': '{amount} toplandi',
    'leaderboard.supporters': '{count} destekci',
    'leaderboard.noSupporters': 'Henuz destekci yok. Ilk siz olun!',
    'leaderboard.noProjectsYet': 'Henuz proje yok. Ilkini gonderin!',

    // Auth Pages
    'auth.welcomeBack': 'Tekrar Hosgeldiniz',
    'auth.loginSubtitle': 'Fikir yayinlamak ve ivme kazanmak icin giris yapin',
    'auth.continueGoogle': 'Google ile Devam Et',
    'auth.or': 'veya',
    'auth.email': 'E-posta',
    'auth.password': 'Sifre',
    'auth.fullName': 'Ad Soyad',
    'auth.logIn': 'Giris Yap',
    'auth.noAccount': 'Hesabiniz yok mu?',
    'auth.signUp': 'Kayit ol',
    'auth.joinFikkr': "Fikkr'a Katil",
    'auth.signupSubtitle': 'Fikirlerini ivmeye donustur',
    'auth.createAccountBtn': 'Hesap Olustur',
    'auth.haveAccount': 'Zaten hesabiniz var mi?',
    'auth.logInLink': 'Giris yap',
    'auth.passwordHint': 'En az 6 karakter',
    'auth.welcomeBackToast': 'Tekrar hosgeldiniz!',
    'auth.accountCreated': "Hesap olusturuldu! Fikkr'a hosgeldiniz.",

    // Profile Page
    'profile.editProfile': 'Profili Duzenle',
    'profile.message': 'Mesaj',
    'profile.joined': '{time} katildi',
    'profile.boostsGiven': '{count} destek verildi',
    'profile.projects': 'Projeler',
    'profile.updates': 'Guncellemeler',
    'profile.recentBoosts': 'Son Destekler',
    'profile.noProjects': 'Henuz proje yok',
    'profile.noProjectsDesc': 'Bu kullanici henuz proje gondermemis',
    'profile.noUpdates': 'Henuz guncelleme yok',
    'profile.shareFirst': 'Ilk guncellemenizi yukari paylasın!',
    'profile.noUpdatesDesc': 'Henuz guncelleme paylasilmamis',
    'profile.noBoosts': 'Henuz destek yok',
    'profile.noBoostsDesc': 'Bu kullanici henuz hicbir projeyi desteklemedi',
    'profile.stats': 'Istatistikler',
    'profile.userNotFound': 'Kullanici Bulunamadi',

    // Edit Profile Page
    'editProfile.title': 'Profili Duzenle',
    'editProfile.back': 'Geri',
    'editProfile.pictureUrl': 'Profil Resmi URL',
    'editProfile.displayName': 'Gorünen Ad',
    'editProfile.bio': 'Biyografi',
    'editProfile.bioPlaceholder': 'Kendinizden bahsedin...',
    'editProfile.saveChanges': 'Degisiklikleri Kaydet',
    'editProfile.cancel': 'Iptal',
    'editProfile.noChanges': 'Kaydedilecek degisiklik yok',
    'editProfile.updated': 'Profil güncellendi!',

    // Messages Page
    'messages.title': 'Mesajlar',
    'messages.newMessage': 'Yeni Mesaj',
    'messages.noConversations': 'Henuz konusma yok',
    'messages.startConversation': 'Biriyle konusma baslatın',
    'messages.findUsers': 'Kullanici Bul',
    'messages.selectConversation': 'Bir konusma secin',
    'messages.chooseConversation': 'Kenar cubugundan bir konusma secin veya yeni bir tane baslatın',
    'messages.typeMessage': 'Mesaj yazin...',
    'messages.send': 'Gonder',
    'messages.you': 'Siz',

    // Following Feed Page
    'followingFeed.title': 'Akis',
    'followingFeed.subtitle': 'Takip ettiginiz kisilerden guncellemeler',
    'followingFeed.loginPrompt': 'Takip ettiginiz kisilerden guncellemeleri gormek icin giris yapin',
    'followingFeed.empty': 'Akiniz bos',
    'followingFeed.emptyDesc': 'Projelerini ve guncellemelerini burada gormek icin kullanicilari takip edin',
    'followingFeed.discoverProjects': 'Projeleri Kesfet',
    'followingFeed.all': 'Tumu',
    'followingFeed.projects': 'Projeler',
    'followingFeed.updates': 'Guncellemeler',
    'followingFeed.yourFeed': 'Akiniz',

    // Notifications
    'notifications.title': 'Bildirimler',
    'notifications.markAllRead': 'Tumunu okundu yap',
    'notifications.empty': 'Henuz bildirim yok',

    // Follow
    'follow.follow': 'Takip Et',
    'follow.following': 'Takip Ediliyor',
    'follow.followers': 'Takipciler',

    // Components
    'component.smartPick': 'Akilli Secim',
    'component.searchUsers': 'Kullanici ara...',
    'component.noUsersFound': 'Kullanici bulunamadi',
    'component.updateDeleted': 'Guncelleme silindi',
    'component.shareUpdate': 'Projenizle ilgili ne var ne yok?',
    'component.selectProject': 'Projeye bagla (istege bagli)',
    'component.noProject': 'Proje yok',
    'component.postUpdate': 'Guncelleme Paylas',

    // Common
    'common.loading': 'Yukleniyor...',
    'common.error': 'Hata',
    'common.save': 'Kaydet',
    'common.cancel': 'Iptal',
    'common.delete': 'Sil',
    'common.search': 'Ara',
    'common.back': 'Geri',

    // Submit Project
    'submit.linksMedia': 'Linkler & Medya',
    'submit.linksMediaDesc': 'Projenize link ekleyin (hepsi istege bagli)',
    'submit.coverImage': 'Kapak Resmi',
    'submit.clickToUpload': 'Resim yuklemek icin tiklayin',
    'submit.imageFormats': 'JPEG, PNG, GIF, WebP (max 5MB)',
    'submit.orPasteUrl': 'Veya resim URL\'si yapistirin:',
    'submit.demoUrl': 'Demo / Web Sitesi URL',
    'submit.invalidImageType': 'Lutfen gecerli bir resim dosyasi secin',
    'submit.imageTooLarge': 'Resim 5MB\'den kucuk olmalidir',
    'submit.imageUploaded': 'Resim basariyla yuklendi!',
    'submit.uploadFailed': 'Resim yuklenemedi',

    // Legal
    'legal.disclaimer': 'Bu platform yatirim teklif etmez. Tum katkilar gonullu destektir. Hisse, kar veya mali getiri vaat edilmemektedir.',
    'legal.notFound': 'Sayfa Bulunamadi',
    'legal.notFoundDesc': 'Aradiginiz sayfa bulunamadi veya henuz olusturulmamis.',

    // Footer
    'footer.kvkk': 'KVKK',

    // Admin Panel
    'admin.title': 'Yonetim Paneli',
    'admin.subtitle': 'Platform yonetimi ve analitikler',
    'admin.refresh': 'Yenile',
    'admin.refreshed': 'Veriler yenilendi',
    'admin.loadError': 'Veriler yuklenemedi',
    'admin.saveError': 'Kaydedilemedi',
    'admin.today': 'bugun',

    // Admin Tabs
    'admin.tabOverview': 'Genel Bakis',
    'admin.tabSettings': 'Site Ayarlari',
    'admin.tabPages': 'Yasal Sayfalar',
    'admin.tabHomepage': 'Ana Sayfa',
    'admin.tabSystem': 'Sistem',

    // Admin Overview
    'admin.totalUsers': 'Toplam Kullanici',
    'admin.totalProjects': 'Toplam Proje',
    'admin.totalBoosts': 'Toplam Destek',
    'admin.totalRaised': 'Toplam Gelir',
    'admin.boostBreakdown': 'Destek Dagilimi',
    'admin.freeBoosts': 'Ucretsiz Destekler',
    'admin.timeBoosts': 'Zaman Destekleri',
    'admin.moneyBoosts': 'Maddi Destekler',
    'admin.flaggedContent': 'Isarretli Icerik',
    'admin.noFlagged': 'Isarretli icerik yok',
    'admin.smartPicks': 'Akilli Secimler',

    // Admin Settings
    'admin.siteInfo': 'Site Bilgileri',
    'admin.siteName': 'Site Adi',
    'admin.logoUrl': 'Logo URL',
    'admin.logoUrlHint': 'Logo resminizin URL\'sini girin. Varsayilan ikonu kullanmak icin bos birakin.',
    'admin.logoPreview': 'Onizleme:',
    'admin.seoTitle': 'SEO Basligi',
    'admin.seoTitleHint': 'Tarayici sekmelerinde ve arama sonuclarinda gosterilir',
    'admin.seoDescription': 'SEO Aciklamasi',
    'admin.seoDescHint': 'Arama motoru sonuclarinda gosterilir (max 160 karakter oneriler)',
    'admin.googleCodes': 'Google Entegrasyonu',
    'admin.gaId': 'Google Analytics ID',
    'admin.gaHint': 'Google Analytics olcum kimliginiz (ornek: G-XXXXXXXXXX)',
    'admin.verificationCode': 'Google Search Console Dogrulama',
    'admin.verificationHint': 'Google dogrulama icin meta etiketi deger',
    'admin.customCode': 'Ozel Kod',
    'admin.customCss': 'Ozel CSS',
    'admin.customHeadScripts': 'Ozel Head Scriptleri',
    'admin.saveSettings': 'Ayarlari Kaydet',
    'admin.settingsSaved': 'Ayarlar basariyla kaydedildi',

    // Admin Pages
    'admin.pageTerms': 'Kullanim Sartlari',
    'admin.pagePrivacy': 'Gizlilik Politikasi',
    'admin.pageKvkk': 'KVKK',
    'admin.pageTitle': 'Sayfa Basligi',
    'admin.pageTitlePlaceholder': 'Sayfa basligini girin...',
    'admin.pageContent': 'Sayfa Icerigi',
    'admin.htmlSupported': '(HTML desteklenir)',
    'admin.pageContentPlaceholder': 'Sayfa icerigini girin (HTML desteklenir)...',
    'admin.pagePreviewHint': 'Onizleme: /page/terms, /page/privacy veya /page/kvkk adresini ziyaret edin',
    'admin.savePage': 'Sayfayi Kaydet',
    'admin.pageSaved': 'Sayfa basariyla kaydedildi',
    'admin.fillRequired': 'Baslik ve icerik gereklidir',

    // Admin Homepage
    'admin.heroSection': 'Hero Bolumu',
    'admin.heroDesc': 'Ana sayfanin hero bolumunu ozellestirin. Varsayilan cevirileri kullanmak icin alanlari bos birakin.',
    'admin.heroTitle1': 'Baslik Kisim 1',
    'admin.heroTitle1Hint': 'Vurgulanan kelimeden onceki metin',
    'admin.heroHighlight': 'Vurgulanan Kelime',
    'admin.heroHighlightHint': 'Degrade renkli anahtar kelime',
    'admin.heroTitle2': 'Baslik Kisim 2',
    'admin.heroSubtitle': 'Alt Baslik',
    'admin.preview': 'Onizleme',
    'admin.saveHomepage': 'Ana Sayfa Kaydet',
    'admin.homepageSaved': 'Ana sayfa ayarlari kaydedildi',

    // Admin System
    'admin.serverInfo': 'Sunucu Bilgileri',
    'admin.status': 'Durum',
    'admin.pythonVersion': 'Python Surumu',
    'admin.platform': 'Platform',
    'admin.databaseInfo': 'Veritabani Bilgileri',
    'admin.dbSize': 'Veritabani Boyutu',
    'admin.collections': 'Koleksiyonlar',
    'admin.totalDocs': 'Toplam Belge',
    'admin.collectionCounts': 'Koleksiyon Sayilari',
    'admin.messages': 'Mesajlar',
    'admin.notifications': 'Bildirimler',

    // Relative time
    'time.justNow': 'az once',
    'time.minutesAgo': '{count}dk once',
    'time.hoursAgo': '{count}sa once',
    'time.daysAgo': '{count}g once',
  },
};

export default translations;
